import { Routes } from '@angular/router';

import { RequestComponent } from './views/appviews/recruitment/request/request.component';
import { LoginComponent } from './views/appviews/login/login.component';

import { BlankLayoutComponent } from './components/common/layouts/blankLayout.component';
import { BasicLayoutComponent } from './components/common/layouts/basicLayout.component';
import { RequestReviewComponent } from './views/appviews/recruitment/request-review/request-review.component';
import { AuthGuardService as AuthGuard } from './shared/services/auth-guard.service';
import { RequisitionReviewComponent } from './views/appviews/opening/requisition-review/requisition-review.component';
import { RequisitionDetailComponent } from './views/appviews/opening/requisition-detail/requisition-detail.component';
import { RoleGuardService as RoleGuard } from './shared/services/role-guard.service';
import { UserComponent } from './views/appviews/security/user/user.component';
import { SystemComponent } from './views/appviews/security/system/system.component';
import { RoleComponent } from './views/appviews/security/Role/role.component';
import { ChangePasswordComponent } from './views/appviews/security/change-password/change-password.component';
import { ProfileComponent } from './views/appviews/recruitment/profile/profile.component';
import { CanDeactivateGuard } from './shared/services/can-deactivate-guard.service';
import { HolidayRequestComponent } from './views/appviews/request/holiday/holiday-request.component';
import { HolidayApprovalComponent } from './views/appviews/request/holiday/holiday-approval.component';
import { InabilityRequestComponent } from './views/appviews/request/inability/inability-request.component';
import { InabilityRecordsComponent } from './views/appviews/request/inability/inability-records.component';
import { WorkLeaveComponent } from './views/appviews/request/work-leave/work-leave.component';
import { WorkLeaveRecordsComponent } from './views/appviews/request/work-leave/work-leave-records.component';
import { CompaniesComponent } from './views/appviews/organization/companies/companies.component';
import { CustomersComponent } from './views/appviews/quote/customers/customers.component';
import { ProjectsComponent } from './views/appviews/quote/projects/projects.component';
import { ProductsComponent } from './views/appviews/quote/products/products.component';
import { ListPositionsComponent } from './views/appviews/quote/positions/list-positions.component';
import { PositionComponent } from './views/appviews/quote/positions/position.component';
import { ListBudgetsComponent } from './views/appviews/quote/budgets/list-budgets.component';
import { BudgetComponent } from './views/appviews/quote/budgets/budget.component';
import { WorkingDaysComponent } from './views/appviews/quote/working-days/working-days.component';
import { NotesComponent } from './views/appviews/quote/notes/notes.component';
import { RelocationComponent } from './views/appviews/request/relocation/relocation.component';
import { RelocationRecordsComponent } from './views/appviews/request/relocation/relocation-records.component';
import { BudgetApprovalComponent } from './views/appviews/quote/budgets/approval/budget-approval.component';
import { AccountActivationComponent } from './views/appviews/security/account-activation/account-activation.component';
import { BudgetApprovalSummaryComponent } from './views/appviews/quote/budgets/approval/budget-approval-summary.component';
import { ListEmployeesComponent } from './views/appviews/employees/list-employees.component';
import { EmployeeUpdateComponent } from './views/appviews/employees/employee-update.component';
import { CustomerCommissionsComponent } from './views/appviews/quote/customer-commissions/customer-commissions.component';
import { ListCommissionsComponent } from './views/appviews/payroll/commissions/list-commissions.component';
import { CommissionDetailComponent } from './views/appviews/payroll/commissions/commission-detail.component';
import { RetroactivesComponent } from './views/appviews/payroll/retroactives/retroactives.component';
import { ListPayrollsComponent } from './views/appviews/payroll/payrolls/list-payrolls.component';
import { PayrollDetailComponent } from './views/appviews/payroll/payrolls/payroll-detail.component';
import { ExternalCustomerCommissionComponent } from './views/appviews/payroll/commissions/external/external-customer-commission.component';
import { ExternalCustomerPayrollComponent } from './views/appviews/payroll/payrolls/external/external-customer-payroll.component';
import { ExternalRecruitmentComponent } from './views/appviews/recruitment/external/external-recruitment.component';
import { EnterAddressComponent } from './views/appviews/recruitment/external/enter-address/enter-address.component';
import { LiquidationComponent } from './views/appviews/request/legal/liquidation/liquidation.component';
import { ListLiquidationsComponent } from './views/appviews/request/legal/liquidation/list-liquidations.component';
import { ApproveConciliationOwnComponent } from './views/appviews/request/legal/liquidation/approval/approve-conciliation-own.component';
import { ExternalRequestCaptureComponent } from './views/appviews/recruitment/external/external-request-capture.component';
import { DashboardComponent } from './views/appviews/dashboard/dashboard.component';
import { IncidentComponent } from './views/appviews/incident/incident.component';
import { IncidentDetailComponent } from './views/appviews/incident/detail/incident.detail.component';
import { DemandComponent } from './views/appviews/request/legal/demands/demand.component';
export const ROUTES: Routes = [
  // Main redirect
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  {
    path: 'dashboard', component: DashboardComponent
  },
  {
    path: 'dashboard', component: BasicLayoutComponent,
    children: [
      {
        path: 'init', component: DashboardComponent
      }
    ]
  },
  // App views
  {
    path: 'recruitments', component: BasicLayoutComponent, canDeactivate: [CanDeactivateGuard],
    children: [
      {
        path: 'request', component: RequestComponent, canActivate: [RoleGuard],
        canDeactivate: [CanDeactivateGuard],
        data: {
          expectedModule: 'Request'
        },
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'request-reviews', component: RequestReviewComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'RequestReviews'
        }
      },
      {
        path: 'profile', component: ProfileComponent
      }
    ]
  },
  {
    path: 'openings', component: BasicLayoutComponent,
    children: [
      {
        path: 'requisition-reviews', component: RequisitionReviewComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'RequisitionReviews'
        }
      },
      {
        path: 'requisition-detail', component: RequisitionDetailComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'RequisitionDetail'
        }
      },
    ]
  },
  {
    path: 'security', component: BasicLayoutComponent,
    children: [
      {
        path: 'users', component: UserComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Users'
        }
      },
      {
        path: 'systems', component: SystemComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Systems'
        }
      },
      {
        path: 'roles', component: RoleComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Roles'
        }
      },
      {
        path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'holidays', component: BasicLayoutComponent,
    children: [
      {
        path: 'request', component: HolidayRequestComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'HolidayRequest'
        }
      },
      {
        path: 'approval', component: HolidayApprovalComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'HolidayApproval'
        }
      }
    ]
  },
  {
    path: 'inabilities', component: BasicLayoutComponent,
    children: [
      {
        path: 'requests', component: InabilityRequestComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Inability'
        }
      },
      {
        path: 'records', component: InabilityRecordsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'InabilityRecords'
        }
      }
    ]
  },
  {
    path: 'works', component: BasicLayoutComponent,
    children: [
      {
        path: 'leave', component: WorkLeaveComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'WorkLeave'
        }
      },
      {
        path: 'records', component: WorkLeaveRecordsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'WorkLeaveRecords'
        }
      }
    ]
  },
  {
    path: 'relocations', component: BasicLayoutComponent,
    children: [
      {
        path: 'create', component: RelocationComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Relocation'
        }
      },
      {
        path: 'records', component: RelocationRecordsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'RelocationRecords'
        }
      }
    ]
  },
  {
    path: 'legal', component: BasicLayoutComponent,
    children: [
      {
        path: 'records', component: ListLiquidationsComponent,
        data: {
          expectedModule: 'LiquidationRecords'
        }
      },
      {
        path: 'liquidation', component: LiquidationComponent,
        data: {
          expectedModule: 'Liquidation'
        }
      },
      {
        path: 'demand', component: DemandComponent,
        data: {
          expectedModule: 'Demand'
        }
      }
    ]
  },
  {
    path: 'catalogs', component: BasicLayoutComponent,
    children: [
      {
        path: 'companies', component: CompaniesComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Companies'
        }
      },
      {
        path: 'customers', component: CustomersComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Customers'
        }
      },
      {
        path: 'projects', component: ProjectsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Projects'
        }
      },
      {
        path: 'products', component: ProductsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Products'
        }
      },
      {
        path: 'working-days', component: WorkingDaysComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'WorkingDays'
        }
      },
      {
        path: 'notes', component: NotesComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Notes'
        }
      },
      {
        path: 'customer-commissions', component: CustomerCommissionsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'CustomerCommissions'
        }
      }
    ]
  },
  {
    path: 'positions', component: BasicLayoutComponent,
    children: [
      {
        path: 'list', component: ListPositionsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Jobs'
        }
      },
      {
        path: 'create', component: PositionComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'JobCreation'
        }
      }
    ]
  },
  {
    path: 'budgets', component: BasicLayoutComponent,
    children: [
      {
        path: 'list', component: ListBudgetsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Budgets'
        }
      },
      {
        path: 'create', component: BudgetComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'BudgetCreation'
        }
      }
    ]
  },
  {
    path: 'budgets', component: BlankLayoutComponent,
    children: [
      {
        path: 'budget-approval', component: BudgetComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'BudgetCreation'
        }
      }
    ]
  },
  {
    path: '', component: BlankLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'budget-approval', component: BudgetApprovalComponent },
      { path: 'activation', component: AccountActivationComponent },
      { path: 'budget-approval-summary', component: BudgetApprovalSummaryComponent },
      { path: 'external-customer-commission', component: ExternalCustomerCommissionComponent },
      { path: 'external-customer-payroll', component: ExternalCustomerPayrollComponent },
      { path: 'external-recruitment', component: ExternalRecruitmentComponent },
      { path: 'enter-address', component: EnterAddressComponent },
      { path: 'approve-conciliation-own', component: ApproveConciliationOwnComponent },
      { path: 'external-request-capture', component: ExternalRequestCaptureComponent },
    ]
  },
  {
    path: 'employees', component: BasicLayoutComponent,
    children: [
      {
        path: 'list', component: ListEmployeesComponent,
        data: {
          expectedModule: 'Employees'
        }
      },
      {
        path: 'update', component: EmployeeUpdateComponent,
        data: {
          expectedModule: 'EmployeeUpdate'
        }
      }
    ]
  },
  {
    path: 'payroll', component: BasicLayoutComponent,
    children: [
      {
        path: 'list', component: ListPayrollsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'PayrollRecords'
        }
      },
      {
        path: 'payroll-detail', component: PayrollDetailComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Payroll'
        }
      },
      {
        path: 'commissions', component: ListCommissionsComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'CommissionRecords'
        }
      },
      {
        path: 'commission-detail', component: CommissionDetailComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Commission'
        }
      },
      {
        path: 'retroactives', component: RetroactivesComponent,
        data: {
          expectedModule: 'Retroactives'
        }
      }
    ]
  },
  {
    path: 'payroll', component: BlankLayoutComponent,
    children: [
      {
        path: 'external-customer-commission', component: CommissionDetailComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Commission'
        }
      },
      {
        path: 'external-customer-payroll', component: PayrollDetailComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Payroll'
        }
      }
    ]
  },
  {
    path: 'recruitments', component: BlankLayoutComponent,
    children: [
      {
        path: 'external-recruitment', component: RequestComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Request'
        }
      },
      {
        path: 'external-request-capture', component: RequestComponent, canActivate: [RoleGuard],
        data: {
          expectedModule: 'Request'
        }
      }
    ]
  },
  {
    path: 'incident', component: BasicLayoutComponent,
    children: [
      {
        path: 'records', component: IncidentComponent
      },
      {
        path: 'detail', component: IncidentDetailComponent
      }
    ]
  },
  // Handle all other routes
  { path: '**', redirectTo: 'login' }
];
